import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import LuxuryResidentialRenovations from "./sections/LuxuryResidentialRenovations";
import OfficeCommercialFitouts from "./sections/OfficeCommercialFitouts";
import IntegratedDesignBuildServices from "./sections/IntegratedDesignBuildServices";
import StartYourRenovationWithConfidence from "./sections/StartYourRenovationWithConfidence";
import ResidentialRenovations from "./sections/ResidentialRenovations";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <Hero />
      <LuxuryResidentialRenovations />
      <ResidentialRenovations />
      <OfficeCommercialFitouts />
      <IntegratedDesignBuildServices />
      <StartYourRenovationWithConfidence />
      <Footer />
    </div>;
}